import { CreateDepositHookByApiKeyDto, DepositHook } from '@heliofi/common';
import { ApiAdapter } from '../../ApiAdapter';

export class DepositWebhookSDK {
  private readonly apiAdapter: ApiAdapter;

  constructor(apiAdapter: ApiAdapter) {
    this.apiAdapter = apiAdapter;
  }

  async createDepositWebhook(
    payload: CreateDepositHookByApiKeyDto,
  ): Promise<DepositHook> {
    return this.apiAdapter.post(
      '/webhook/deposit/api-key',
      payload,
      'Failed to create deposit webhook',
    );
  }
}
